// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h2 {\n  text-align: center;\n}\n\n#AddButton {\n  text-align: start;\n}", "",{"version":3,"sources":["webpack://src/pages/Subscriptions/Subscription.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF","sourcesContent":["// Variables\n@import \"../../assets/css/vars\";\n\nh2 {\n  text-align: center;\n}\n\n#AddButton {\n  text-align: start;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
